import styled from "styled-components";

const StyledTitleModal = styled.h1`
    color: #1e1e1e;
    font-weight: 700;
    font-size: 24px;
    text-align: center;
`;

const StyledButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 30px;
    gap: 15px;
`;

export default {
    StyledTitleModal,
    StyledButtonContainer,
};
